module.exports = __webpack_public_path__ + "img/13.0fc82b62.jpg";